enum TabOptions {
  Active = 0,
  Disabled = 1,
}

export default TabOptions;
